export enum EmployeeTab {
  INFO,
  CONTRACTS,
  EVENTS,
  COURSES,
  SCHEDULE,
  FINANCE_REPORT,
  LEAVING,
  DOCUMENTS,
  MESSAGES,
  ACTIVATION,
  PAYROLL,
  MULTI_SITE_ROLES,
  HISTORY,
  FINANCE_DATA,
}
